import { Module } from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { State } from '@/main/store'
import { HomeDataInitialState } from './types'
const homeStore: Module<HomeDataInitialState, State> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
export default homeStore
